import { useState } from "react";
import { websitePosterUrl } from "../utils/mediaUrls.mjs";

export default function MoviePoster({ movieId, title, urls = [], compact = false }) {
  const sources = [...new Set(urls.map(websitePosterUrl).filter(url => url?.trim()))].slice(0, 3);
  return <Poster key={`${movieId}:${sources.join("|")}`} title={title} sources={sources} compact={compact} />;
}

function Poster({ title, sources, compact }) {
  const [index, setIndex] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const src = sources[index];
  return (
    <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-gradient-to-br from-slate-800 to-slate-950">
      {!loaded && (
        <div role={src ? undefined : "img"} aria-label={src ? undefined : title} aria-hidden={src ? true : undefined}
          data-poster-placeholder="true"
          className={`absolute inset-0 flex flex-col items-center justify-center border border-white/10 text-center text-slate-300 ${compact ? "gap-1 p-1" : "gap-3 p-3"}`}>
          {!compact && <svg aria-hidden="true" viewBox="0 0 24 24" className="h-10 w-10 text-slate-500" fill="none" stroke="currentColor" strokeWidth="1.5">
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <path d="M7 3v18M17 3v18M3 8h4m-4 8h4m10-8h4m-4 8h4" />
          </svg>}
          <span className={compact ? "line-clamp-4 text-[8px] leading-tight" : "text-xs font-medium leading-snug"}>{title}</span>
          <span className={compact ? "sr-only" : "text-[10px] text-slate-400"}>{src ? "Loading poster…" : "Poster unavailable"}</span>
        </div>
      )}
      {src && <img key={src} src={src} alt={title} decoding="async" loading="lazy"
        className={`absolute inset-0 h-full w-full object-cover ${loaded ? "opacity-100" : "opacity-0"}`}
        onLoad={() => setLoaded(true)}
        onError={() => { setLoaded(false); setIndex(current => current + 1); }}
      />}
    </div>
  );
}
